const latLngOptions: { [key: string]: [number, number] } = {
	bialystok: [53.132315, 23.16435],
	bielskobiala: [49.82214, 19.056564],
	bydgoszcz: [53.122543, 18.007561],
	czestochowa: [50.812217, 19.116068],
	kielce: [50.864458, 20.626579],
	krakow: [50.064651, 19.944981],
	lodz: [51.759478, 19.454927],
	lublin: [51.247853, 22.559974],
	olsztyn: [53.778944, 20.476619],
	opole: [50.667836, 17.921288],
	poland: [51.919437, 19.145136],
	poznan: [52.406376, 16.9251681],
	rzeszow: [50.039088, 22.007573],
	slask: [50.286855, 18.950123],
	szczecin: [53.428935, 14.5574],
	torun: [53.013353, 18.598115],
	trojmiasto: [54.433464, 18.567381],
	warszawa: [52.229675, 21.01223],
	wroclaw: [51.1086, 17.038333],
	zielonagora: [51.936619, 15.50869],
}
export default latLngOptions
